module.exports = __webpack_public_path__ + "img/p__河北工程.fdfdd957.png";